import { AppData } from "@lightningjs/sdk";
import { AppSetup } from "../app-setup";
import CuePointsManager from "./ad-cuepoint-manager";
import { Logger } from "../logger";
import AppModel from "../models/app-model";
import { Helper } from "../helper";

export default class IMAAdHandler{
    cuePointsManager!:CuePointsManager
    adDisplayContainer!:HTMLElement;
    videoContent!:HTMLVideoElement;
    adsLoader:any;
    currentVodInfo:any;
    currentAdProvider:any;
    adHandler:any;
    adsManager:any;
    totalAds=0;
    dedupeId:any;
    constructor(){

    }

    setUpIMA = () => {
        const { appState, appConfig } = AppData as AppSetup;
        const app = appState?.getApp();
		if (this.adDisplayContainer) return;
		Logger.printLog('data', 'setUpIMA: ', '');
		// Create the ad display container.
		this.videoContent = document.getElementById('adVideo') as HTMLVideoElement;
		
        this.adHandler = app?.adHandler;
        // IPTV-2394 - as the ima has fixes the ima bridge issue we are supporting the ads. again.
        // if(navigator.userAgent.indexOf('Tizen 3.0')>=0) {
        //     appConfig?.disableAds = true
        //     return
        // }
        if(window.google && google.ima && google.ima.AdDisplayContainer && google.ima.AdsLoader && google.ima.AdsManagerLoadedEvent && google.ima.AdErrorEvent) {

            this.createAdDisplayContainer();
            
            // Create ads loader.
            // @ts-ignore
            this.adsLoader = new google.ima.AdsLoader(this.adDisplayContainer);

		// Listen and respond to ads loaded and error events.
		this.adsLoader.addEventListener(
			google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
			this.onAdsManagerLoaded,
			false);
		this.adsLoader.addEventListener(
			google.ima.AdErrorEvent.Type.AD_ERROR,
			this.onAdError,
			false);
		 	google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.DISABLED);
        } else {
            Logger.printLog('error', 'Google IMA SDK not loaded properly', '');
            //throw new Error('Google IMA SDK not loaded properly');
            appConfig?.disableAds = true;
        }
        
	}

    /*onContentVideoEnded = () => {
        const { appConfig } = AppData as AppSetup;
        if(appConfig.disableAds == false && typeof this.adsLoader !== 'undefined') {
            this.adsLoader.contentComplete();
        }
    }*/

    resetIma = () => {        
        const { appConfig } = AppData as AppSetup;
        if(appConfig.useVmap == false) {	
            if(this.cuePointsManager != null) {                
                this.cuePointsManager.destroy();
                this.cuePointsManager = null;
            }
            this.adHandler.hideAdVideoElem();
        }
        /*if(this.adsManager) {
            this.adsManager.destroy();
            this.adsManager = null;
        }*/
    }



    createAdDisplayContainer() {
        // We assume the adContainer is the DOM id of the element that will house the ads.
        this.adDisplayContainer = new google.ima.AdDisplayContainer(document.getElementById('displayBaseIMA'), this.videoContent);
    }

    onAdError = (adErrorEvent) => {        
		// Handle the error logging.
		Logger.printLog('data', 'adErrorEvent.getError(), adErrorEvent.getError().getErrorCode()', [adErrorEvent.getError(), adErrorEvent.getError().getErrorCode()]);

		let adsManagerContext = adErrorEvent.getUserRequestContext();
        //console.log('SURESH onAdError podIndex',adsManagerContext.podIndex)
		adsManagerContext.onAdError(adErrorEvent);
	}

    onAdsManagerLoaded = (adsManagerLoadedEvent) => {        
		Logger.printLog('info', 'onAdsManagerLoaded', adsManagerLoadedEvent);		
        const { appConfig } = AppData as AppSetup;
		// Get the ads manager.
		let adsRenderingSettings = new google.ima.AdsRenderingSettings();
        adsRenderingSettings.loadVideoTimeout = 20000;
		adsRenderingSettings.bitrate = 6000;  // Based on VIZIO Documentaion not more than 20000 kb/s 
        let _adsManager = adsManagerLoadedEvent.getAdsManager(null, adsRenderingSettings);
        let adsManagerContext = adsManagerLoadedEvent.getUserRequestContext();
        adsManagerContext.addAdsManager(_adsManager);
        _adsManager.init(appConfig.appUIConfig.winW, appConfig.appUIConfig.winH, google.ima.ViewMode.NORMAL);
        this.adsManager = _adsManager;
    }
    /**
	 * @description - Its a listener method, this method handles what should be done whenever an ad event occurs like loaded, started, complete etc. 
	 * Here, we also make the logging call for ad complete scenario. 
	 * @param {ima.AdEvent} - "adEvent"
	 * @param - "adEvent"
	*/
	onAdEvent = (adEvent, customAdPodInfo) => {        
        if(adEvent && adEvent.type!="adProgress"){
            Logger.printLog('data', 'ima-ad-handler.ts onAdEvent: ', adEvent.type);            
        }
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();        
        let ads = app?.ads;

		const adHandler = app.adHandler;

        switch (adEvent.type) {
			case google.ima.AdEvent.Type.LOADED:                
				var ad = adEvent.getAd();
				Logger.printLog('data', 'adsManagerLoadedCallback# loaded, Ad Details JSON: ', JSON.stringify(ad));                
                var adPodInfo = customAdPodInfo;
                if(appConfig?.enableIMAAdPodding){
                    adPodInfo=adEvent.getAdData().adPodInfo;
                }				
                if(appConfig?.enableIMAAdPodding){
                    this.totalAds=adEvent.getAdData().adPodInfo.totalAds
                } else {
                    this.totalAds=customAdPodInfo.totalAds
                }
				break;

			case google.ima.AdEvent.Type.AD_BREAK_READY:
				Logger.printLog('info', 'onAdEvent READY NOW - going to play', adEvent.getAdData());							
				break;
			case google.ima.AdEvent.Type.FIRST_QUARTILE:
			case google.ima.AdEvent.Type.MIDPOINT:
			case google.ima.AdEvent.Type.THIRD_QUARTILE:				
				break;
			case google.ima.AdErrorEvent.Type.AD_ERROR:
				//loaderComponent.showVideoLoader();
				break;
			case google.ima.AdEvent.Type.LOG:
				break;
			case google.ima.AdEvent.Type.STARTED:                
				var ad = adEvent.getAd();
                var adPodInfo = customAdPodInfo;
                if(appConfig?.enableIMAAdPodding){
                    let freeWheelAds = app?.freeWheelAds;
                    let fwtotalAdsInPod = freeWheelAds?.totalAdsInPod
                    adPodInfo=adEvent.getAd().getAdPodInfo();
                    const currentAd = adPodInfo.getAdPosition();
                    const totalAds = adPodInfo.getTotalAds()  + fwtotalAdsInPod;
                    let currentAdCount = currentAd + fwtotalAdsInPod;
                    $('.custom-ad-number').text(`${currentAdCount} / ${totalAds}`);
                } else {                    
                    //$('.custom-ad-number').text(`${adPodInfo.adPosition} / ${adPodInfo.totalAds}`);
                    /*adPodInfo=adEvent.getAd().getAdPodInfo();
                    const currentAd = adPodInfo.getAdPosition();
                    const totalAds = adPodInfo.getTotalAds();
                    console.log("IPTV-DEV STARTED ",currentAd + ' of ' + totalAds);
                    $('.custom-ad-number').text(`${currentAd} / ${totalAds}`);*/
                }
				//var adPodInfo = (customAdPodInfo || adEvent.getAdData().adPodInfo);
				//$('#adPodText').text(adPodInfo.adPosition + ' of ' + adPodInfo.totalAds);
				//loaderComponent.hideVideoLoader();
				adHandler.showHideAdLabel('show');
				//clearTimeout(this.clearAdLoadTimeoutIntv);
				ads.adPaused = false;
				break;

			case google.ima.AdEvent.Type.COMPLETE:
                adHandler.showHideAdLabel('hide');
				this.onAdComplete();
				break;

			case google.ima.AdEvent.Type.PAUSED:
				Logger.printLog('info', 'onAdEvent PAUSED - setting ad state', '');
				ads.adPaused = true;
				break;
			case google.ima.AdEvent.Type.RESUMED:
				Logger.printLog('info', 'onAdEvent RESUMED - setting ad state', '');
				ads.adPaused = false;
				break;
			case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
				this.onContentPauseRequested();
				break;
			case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                adHandler.showHideAdLabel('hide');
				this.onContentResumeRequested();
				break;

		}
    }
    
    requestFusePrefetch = (videoInfo:any, noMidAds:Number,cuePointTime:Number) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        this.currentVodInfo = videoInfo;
        const app = appState?.getApp();
        let adObj = app?.adObj;
        var adProvider = adObj.adsdklist[0]; 
        var  adTagUrl = adProvider.url;
        Logger.printLog('info','adProvider.url ',adProvider.url);
        if (adTagUrl.indexOf('[FT_NO_OF_SLOTS]') > -1) {
            adTagUrl = adTagUrl.split('[FT_NO_OF_SLOTS]').join(noMidAds);                
        }
        var urlWithReplacedMacros = this.replaceMacros(adTagUrl, 'midroll','','1');
        this.dedupeId = Helper.getQueryParamValueFromUrl(urlWithReplacedMacros,'FT_DEDUPE_ID')
        //this.adProviders[0].url = urlWithReplacedMacros
        urlWithReplacedMacros = urlWithReplacedMacros + `&PREFETCH_SECOND_REQUEST=false&FT_PREFETCH_REQUEST=1`;
        Logger.printLog('info','FUSE PF this.adProviders ',urlWithReplacedMacros);
        Helper.sendFusePrefetchRequest(urlWithReplacedMacros)
    }

    requestFallback = (videoInfo:any, noMidAds:Number,cuePointTime:Number) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;
        let ads = app?.ads;
		//should only be called ones for each Video.
        Logger.printLog('data', 'requestFallback called - videoInfo, noMidAds', [videoInfo, noMidAds]);		
		//helper.videoloaderDisplay('show');	
		this.currentVodInfo = videoInfo;
		// normal
		var shouldRequestAd = true;
		// if(adType == 'preroll') {
		// 	shouldRequestAd = adHandler.checkIfPreRollBeRequested();
		// } else {

		// }
		var queryArr = {};
		//ads.currentVodCuePoints = this.getCuePoints(videoInfo);
		queryArr.noPreAds = 0;
		queryArr.noMidAds = noMidAds;
		queryArr.cuePoints = [cuePointTime];		
		queryArr.adProviders = [];
        
		//var adProvider = adObj.adsdklist[0];        
        this.updateQueryArr(adObj, queryArr);
		this.currentAdProvider = queryArr.adProviders[0];
		queryArr.videoInfo = videoInfo;
		this.cuePointsManager = new CuePointsManager(queryArr, this.adsLoader, this.onAdEvent, videoInfo, this);
		Logger.printLog('info', 'requestAds shouldRequestAd: ', shouldRequestAd);

        let currentTime = cuePointTime-10;
        if(appConfig.prefetchAds == true) {
            currentTime = cuePointTime-appConfig.prefetchTiming;
        }
        this.cuePointsManager.updateCurrentTime(currentTime);		
	}

    requestFallbackPreroll = (videoInfo:any, noPreAds:Number,cuePointTime:Number) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;
        let ads = app?.ads;		
        Logger.printLog('data', 'requestFallback called - videoInfo, noPreAds', [videoInfo, noPreAds]);				
		this.currentVodInfo = videoInfo;		
		var shouldRequestAd = true;		
		var queryArr = {};		
		queryArr.noPreAds = noPreAds;
        queryArr.noMidAds = 0;
        queryArr.cuePoints = [cuePointTime];        
        queryArr.adProviders = [];
        this.updateQueryArr(adObj, queryArr);
        /*for (var i = 0; i < adObj.adsdklist.length; i++) {
            var adProvider = adObj.adsdklist[i];

            queryArr.adProviders.push({
                name: adProvider.name,
                provider: adProvider.provider,
                priority: adProvider.priority,
                type: adProvider.type,
                url: adProvider.url,
                rowId: adProvider.rowId
            });
        }*/
		this.currentAdProvider = queryArr.adProviders[0];
		queryArr.videoInfo = videoInfo;
		this.cuePointsManager = new CuePointsManager(queryArr, this.adsLoader, this.onAdEvent, videoInfo, this);
        this.cuePointsManager.requestAds(0, false);        		
	}

    /*
		@description - this method creates a new object for Google IMA Ad Request class, and makes a call to fetch ads using the global variable adObj.adUrl only. Other settings can be configured using the adsRequest object properties.  
		@param - none
		@returnValue - none
	*/
    requestAds = (videoInfo, adType) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;
        let ads = app?.ads;
		//should only be called ones for each Video.		
        Logger.printLog('data', 'requestAds called - videoInfo, appConfig.useVmap, adType', [videoInfo, appConfig.useVmap, adType]);		
		this.currentVodInfo = videoInfo;		
		var shouldRequestAd = false;
		var queryArr = {};
		ads.currentVodCuePoints = this.getCuePoints(videoInfo);
        /** [Fix for XFIN-1307] START */
        queryArr.noPreAds = 0;
        if(adObj.adInterval>0 && appState.player.noVideosStarted % adObj.adInterval == 0){            
            queryArr.noPreAds = (appState.player.noVideosStarted > (adObj.firstadInterval) ? adObj.nonmidrollsize : 0);            
        }
        /** [Fix for XFIN-1307] END */
		if (appState.player.videoStartedFromResumePoint !== 0) {
			queryArr.noPreAds = 0;
		}

		queryArr.noMidAds = adObj.midrollsize;
		queryArr.cuePoints = ads.currentVodCuePoints;
		if (queryArr.noPreAds > 0) {
			shouldRequestAd = true;
			//include the preroll cuePoint.
			queryArr.cuePoints.splice(0, 0, 0);
		}
		//queryArr.adUrl = adHandler.replaceMacros(adObj.adUrl);
		queryArr.adProviders = [];
        this.updateQueryArr(adObj, queryArr);		
		this.currentAdProvider = queryArr.adProviders[0];
		queryArr.videoInfo = videoInfo;
		this.cuePointsManager = new CuePointsManager(queryArr, this.adsLoader, this.onAdEvent, videoInfo, this);
		Logger.printLog('info', 'requestAds shouldRequestAd: ', shouldRequestAd);


		if (shouldRequestAd) {
			this.cuePointsManager.requestAds(0, true);
		} else {
            this.onContentResumeRequested();			
		}
	}


    updateQueryArr = (adObj:any, queryArr:any) => {    
        const { appConfig } = AppData as AppSetup;    
        var providerCount = adObj.adsdklist.length;
        if(appConfig?.enableIMAAdPodding) {
            providerCount = 1;
        }
        for (var i = 0; i < providerCount; i++) {
			var adProvider = adObj.adsdklist[i];
			queryArr.adProviders.push({
				name: adProvider.name,
				provider: adProvider.provider,
				priority: adProvider.priority,
				type: adProvider.type,
				url: adProvider.url,
				rowId: adProvider.rowId
			});
		}        
        /*for (var i = 0; i < adObj.adsdklist.length; i++) {
            var adProvider = adObj.adsdklist[i];

            queryArr.adProviders.push({
                name: adProvider.name,
                provider: adProvider.provider,
                priority: adProvider.priority,
                type: adProvider.type,
                url: adProvider.url,
                rowId: adProvider.rowId
            });
        }*/
    }



    getCuePoints = (videoInfo) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;        
        let ads = app?.ads;       

            if (adObj.adActivation !== false && adObj.enableMidAd !== false) {
                Logger.printLog('info', 'getting ad breaks', '');
                if (app?.appApiConfig.adsdkConfig.enableCuePts == "false" || app?.appApiConfig.adsdkConfig.enableCuePts == false) {
                    ad_breaks = this.calculateMidAdPoints(videoInfo.runtime);
                } else {
                    var ad_breaks = videoInfo.ad_breaks;
                    if (!ad_breaks || ad_breaks == '') {
                        ad_breaks = this.calculateMidAdPoints(videoInfo.runtime);
                    } else {
                        ad_breaks = ad_breaks.split(',');
                        $(ad_breaks).each(function (i, val) {
                            ad_breaks[i] = parseInt(val);
                        });
                    }
                }
                ads.currentVodCuePoints = ad_breaks;
            }
            return ads.currentVodCuePoints;
	}

    calculateMidAdPoints = (videoDuration) => {
        const { appConfig, platform, appState } = AppData as AppSetup;
        const app = appState?.getApp();
        let adObj = app?.adObj;    
		var midAdPoints = [];
		if (videoDuration !== null && videoDuration !== undefined && videoDuration !== 0) {
			if (adObj.enableMidAd == true && adObj.midAdTimeInterval > 0 && videoDuration > adObj.midAdTimeInterval) {
				var midAdTimeIntervalInSeconds = adObj.midAdTimeInterval * 60;
				var noMidAdPoints = Math.floor(videoDuration / midAdTimeIntervalInSeconds);
				//if(consoleDebugLog == true) console.log('noMidAdPoints, midAdTimeIntervalInSeconds: ', noMidAdPoints, midAdTimeIntervalInSeconds);
				Logger.printLog('info', 'noMidAdPoints, midAdTimeIntervalInSeconds: ', [noMidAdPoints, midAdTimeIntervalInSeconds]);
				var vodTime = 0;
				for (var i = 1; i <= noMidAdPoints; i++) {
					vodTime = vodTime + midAdTimeIntervalInSeconds
					// if ((videoDuration - vodTime) > midAdTimeIntervalInSeconds) {
					midAdPoints.push(vodTime);
					// }
				}
				Logger.printLog('info', 'vodTime, midAdPoints: ', [vodTime, midAdPoints]);
				//if (consoleDebugLog == true) console.log('vodTime, midAdPoints', vodTime, midAdPoints);
			}
		}
		return midAdPoints;
	}

	replaceMacros = (adUrl:any, context = '', breakPosition = '', slotPosition = '') => {
		const { appConfig, platform, appState } = AppData as AppSetup;        
		const app = appState?.getApp();
    	const appApiConfig = app?.appApiConfig;
		const adHandler = app.adHandler;
        let ads = app?.ads;

        Logger.printLog('data', 'replacing macros adUrl: ', adUrl);

        if (adUrl !== undefined) {

            var newAdUrl = adUrl;
            if(appConfig?.testIMAMacro){
                newAdUrl += '&FT_MASKED_IP=[FT_MASKED_IP]';
                newAdUrl += '&FT_SYNTHETIC_AD_ID=[FT_SYNTHETIC_AD_ID]';
                newAdUrl += '&FT_L1_AG=[FT_L1_AG]';
                newAdUrl += '&FT_CONTENT_PRODUCER=[FT_CONTENT_PRODUCER]';
                newAdUrl += '&FT_APP_VERSION=[FT_APP_VERSION]';
                //appConfig?.buildVersion                        
                // newAdUrl += '&dedup=[FT_DEDUPE_ID]';
            }
            

            Logger.printLog('adlog', 'replacing macros adUrl is defined ','');

            // REQUIRED - Highest Priority
            if (newAdUrl.indexOf('[FT_TRACKING_ID]') > -1) {
                // newAdUrl = newAdUrl.split('[FT_TRACKING_ID]').join(appConfig.currentDeviceId);
                newAdUrl = newAdUrl.split('[FT_TRACKING_ID]').join(platform?.getIFA());
            }

            if (newAdUrl.indexOf('[FT_TRACKING_ENABLED]') > -1) {
                newAdUrl = newAdUrl.split('[FT_TRACKING_ENABLED]').join(platform?.getLimitAdTracking());
            }

            if (newAdUrl.indexOf('[FT_IFA_TYPE]') > -1) {
                newAdUrl = newAdUrl.split('[FT_IFA_TYPE]').join(platform?.getIFAType());
            }            

            if (newAdUrl.indexOf('[FT_USER_AGENT]') > -1) {                
				newAdUrl = newAdUrl.split('[FT_USER_AGENT]').join(encodeURIComponent(platform?.getUA()));
            }

            if (newAdUrl.indexOf('[FT_PLAYER_HEIGHT]') > -1) {                
                newAdUrl = newAdUrl.split('[FT_PLAYER_HEIGHT]').join('1080');
            }

            if (newAdUrl.indexOf('[FT_PLAYER_WIDTH]') > -1) {
                newAdUrl = newAdUrl.split('[FT_PLAYER_WIDTH]').join('1920');
            }

            if (newAdUrl.indexOf('[FT_IP_ADDRESS]') > -1) {
                newAdUrl = newAdUrl.split('[FT_IP_ADDRESS]').join(platform?.getIp());
            }

            if (newAdUrl.indexOf('[FT_MASKED_IP]') > -1) {
                var maskedIp = platform?.getIp();
                if(appApiConfig && appApiConfig.appConfig && appApiConfig.appConfig.genre && appApiConfig.appConfig.genre.toLocaleLowerCase() !== 'movies'){
                    maskedIp = Helper.getMaskedIp(platform?.getIp());
                }
                newAdUrl = newAdUrl.split('[FT_MASKED_IP]').join(maskedIp);
            }

            if (newAdUrl.indexOf('[FT_APP_NAME]') > -1) {				
                newAdUrl = newAdUrl.split('[FT_APP_NAME]').join(encodeURI(platform?.getAppNameMacro(appApiConfig.appConfig.site_name, appConfig.siteId)));
            }

            if (newAdUrl.indexOf('[FT_BUNDLE_ID]') > -1) {
                newAdUrl = newAdUrl.split('[FT_BUNDLE_ID]').join(adHandler.getBundleId());
            }

            if (newAdUrl.indexOf('[FT_APP_STORE_ID]') > -1) {
                newAdUrl = newAdUrl.split('[FT_APP_STORE_ID]').join(platform?.getAppStoreId('ad'));
            }

            if (newAdUrl.indexOf('[FT_TIMESTAMP]') > -1) {
                newAdUrl = newAdUrl.split('[FT_TIMESTAMP]').join(Date.now());
            }

            try {
                //RECOMMENDED - Medium Priority
                var vodInfo = this.currentVodInfo;

                if (newAdUrl.indexOf('[FT_CONTENT_ID]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_ID]').join(vodInfo['node_id']);
                }

                if (newAdUrl.indexOf('[FT_CONTENT_TITLE]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_TITLE]').join($.trim(vodInfo['title']));
                }

                if (newAdUrl.indexOf('[FT_CONTENT_SERIES]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_SERIES]').join($.trim(vodInfo['series_name']));
                }

                if (newAdUrl.indexOf('[FT_CONTENT_LENGTH]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_LENGTH]').join(vodInfo['runtime']);
                }

                if (newAdUrl.indexOf('[FT_CONTENT_RATING]') > -1) {
                    const rating = platform?.getRatingMacro(vodInfo['age_appropriate_rating']);
                    newAdUrl = newAdUrl.split('[FT_CONTENT_RATING]').join(rating);
                }

                if (newAdUrl.indexOf('[FT_CONTENT_GENRE]') > -1) {
                    const genres = platform?.getGenreMacro(vodInfo['content_genre'] || []);
                    newAdUrl = newAdUrl.split('[FT_CONTENT_GENRE]').join($.trim(genres));
                }

                if (newAdUrl.indexOf('[FT_PRIMARY_GENRE]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_PRIMARY_GENRE]').join($.trim(vodInfo['primary_genre']));
                }

                if (newAdUrl.indexOf('[FT_CONTENT_CATEGORY]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_CATEGORY]').join($.trim(vodInfo['primary_category']));
                }

                if (newAdUrl.indexOf('[FT_CONTENT_SEASON]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_SEASON]').join($.trim(vodInfo['season']));
                }

                if (newAdUrl.indexOf('[FT_CONTENT_EPISODE]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_CONTENT_EPISODE]').join($.trim(vodInfo['episode']));
                }

                // New macros - BEGIN
                if (newAdUrl.indexOf('[FT_VIDEO_ID]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_VIDEO_ID]').join(vodInfo['node_id']);
                }

                if (newAdUrl.indexOf('[FT_PUBLISHER]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_PUBLISHER]').join(encodeURI($.trim(vodInfo['author'])));
                }

                if (newAdUrl.indexOf('[FT_PUBLISHER_ID]') > -1) {
                    newAdUrl = newAdUrl.split('[FT_PUBLISHER_ID]').join(encodeURI($.trim(vodInfo['uid'])));
                }
                
                if (newAdUrl.indexOf('[FT_CONTENT_PRODUCER]') > -1) {                    
                    newAdUrl = newAdUrl.split('[FT_CONTENT_PRODUCER]').join(encodeURI($.trim(vodInfo['author'])));
                }

                if (newAdUrl.indexOf('[FT_L1_AG]') > -1) {
                    let l1 = app.navigation.getCurrentL1();
                    newAdUrl = newAdUrl.split('[FT_L1_AG]').join(encodeURIComponent(l1));
                }

                /*if (newAdUrl.indexOf('[FT_PLAYLIST]') > -1) {
                    if (appState.previousPage == 'listoflist') {
                        newAdUrl = newAdUrl.split('[FT_PLAYLIST]').join(encodeURI(subChannels[appState.grid.currentRowFocus].name));
                    } else {
                        newAdUrl = newAdUrl.split('[FT_PLAYLIST]').join(encodeURI(subCategories[appState.grid.currentRowFocus].name));
                    }
                }*/
                // New macros - END

            } catch (e) {
                Logger.printLog('error', 'error getting medium macros','');
            }

            if (newAdUrl.indexOf('[FT_DEVICE_OS]') > -1) {
                var deviceOS = navigator.platform;
                if (appConfig.platform_id == 1217562 && typeof window.VIZIO !== 'undefined' && typeof navigator !== 'undefined') {
                    deviceOS = navigator.platform;
                }
                newAdUrl = newAdUrl.split('[FT_DEVICE_OS]').join(deviceOS);
            }

            if (newAdUrl.indexOf('[FT_DEVICE_OS_VER]') > -1) {
                newAdUrl = newAdUrl.split('[FT_DEVICE_OS_VER]').join('');
            }

            /*if (newAdUrl.indexOf('[FT_DEVICE_MAKE]') > -1) {
                var deviceMake = '';
                if (appConfig.platform_id == 1217562 && typeof window.VIZIO !== 'undefined') {
                    if (typeof window.VIZIO.deviceInfo !== 'undefined' && window.VIZIO.deviceInfo !== null && typeof window.VIZIO.deviceInfo.modelSeries !== 'undefined') {
                        deviceMake = window.VIZIO.deviceInfo.modelSeries;
                    }
                }
                newAdUrl = newAdUrl.split('[FT_DEVICE_MAKE]').join(deviceMake);
            }*/

            if (newAdUrl.indexOf('[FT_DEVICE_MODEL]') > -1) {
                var deviceModel = platform?.getFullModel();
                /*if (appState.playlistPlayMode == false) {
                    if (appConfig.platform_id == 1217562 && typeof window.VIZIO !== 'undefined' && typeof window.VIZIO.deviceModel !== 'undefined') {
                        var deviceModel = window.VIZIO.deviceModel;
                    } else {
                        var deviceModel = appConfig.deviceModel;
                    }
                } else {
                    var deviceModel = appConfig.deviceModel;
                }*/
                newAdUrl = newAdUrl.split('[FT_DEVICE_MODEL]').join(deviceModel);
            }

            if (newAdUrl.indexOf('[FT_DEVICE_LANGUAGE]') > -1) {
                newAdUrl = newAdUrl.split('[FT_DEVICE_LANGUAGE]').join(navigator.language);
            }

            /*if (newAdUrl.indexOf('[FT_APP_VERSION]') > -1) {
                newAdUrl = newAdUrl.split('[FT_APP_VERSION]').join(platform?.getFullModel());
            }*/

            if (newAdUrl.indexOf('[FT_APP_VERSION]') > -1) {
                newAdUrl = newAdUrl.split('[FT_APP_VERSION]').join(appConfig?.buildVersion);
            }

            if (newAdUrl.indexOf('[FT_APP_STORE_URL]') > -1) {
                const name = platform?.getAppNameMacro(appApiConfig.appConfig.site_name, appConfig.siteId)
                newAdUrl = newAdUrl.split('[FT_APP_STORE_URL]').join(encodeURIComponent(platform?.getAppStoreUrlMacro(name, appConfig.siteId)));
            }

            /*if (newAdUrl.indexOf('[appurl]') > -1) {
                var appUrl = appConfig.baseAppUrl + '?iptv=true&siteId=' + appConfig.siteId + '&platform_id=' + appConfig.platform_id;
                newAdUrl = newAdUrl.split('[appurl]').join(encodeURIComponent(appUrl));
            }*/

            // New macros - BEGIN
            if (newAdUrl.indexOf('[FT_CONTEXT]') > -1) {
                if (context == 'preroll') {
                    var contextVal = 1;
                } else {
                    var contextVal = 2;
                }
                newAdUrl = newAdUrl.split('[FT_CONTEXT]').join(contextVal);
            }            

            if (newAdUrl.indexOf('[FT_AD_BREAK_POSITION]') > -1) {
                if (context == 'preroll') {
                    breakPosition = 0;
                }
                if(appConfig?.enableIMAAdPodding){
                    if(appConfig?.adSdkToUse == 'ima'){
                        breakPosition = breakPosition;
                    } else {
                        let freeWheelAds = app?.freeWheelAds;
                        breakPosition = freeWheelAds.breakPosition;
                    }
                    
                }                
                newAdUrl = newAdUrl.split('[FT_AD_BREAK_POSITION]').join(breakPosition);
            }

            if (newAdUrl.indexOf('[FT_AD_SLOT_POSITION]') > -1) {
                newAdUrl = newAdUrl.split('[FT_AD_SLOT_POSITION]').join(slotPosition);
            }

            if (newAdUrl.indexOf('[FT_SESSION_ID]') > -1) {
                newAdUrl = newAdUrl.split('[FT_SESSION_ID]').join(appConfig.sessionId);
            }

            if (newAdUrl.indexOf('[FT_SITE_ID]') > -1) {
                newAdUrl = newAdUrl.split('[FT_SITE_ID]').join(appConfig.siteId);
            }

            if (newAdUrl.indexOf('[FT_US_PRIVACY]') > -1) {
                newAdUrl = newAdUrl.split('[FT_US_PRIVACY]').join(appApiConfig.appConfig.us_privacy);
            }

            if (newAdUrl.indexOf('[FT_SYNTHETIC_AD_ID]') > -1) {                
                //var syntheticAdId = Helper.getSyntheticAdId(platform?.getDeviceId());
                var syntheticAdId = Helper.getSyntheticAdId(platform?.getIFA());
                newAdUrl = newAdUrl.split('[FT_SYNTHETIC_AD_ID]').join(syntheticAdId);
            }
            // New macros - END		

            // Live Macros - BEGIN
            // try {
            if (newAdUrl.indexOf('[APP_NAME]') > -1) {
                newAdUrl = newAdUrl.split('[APP_NAME]').join(encodeURI(platform?.getAppNameMacro(appApiConfig.appConfig.site_name, appConfig.siteId)));
            }
            if (newAdUrl.indexOf('[DID]') > -1) {
                newAdUrl = newAdUrl.split('[DID]').join(platform?.getIFA());
            }
            if (newAdUrl.indexOf('[APP_BUNDLE]') > -1) {
                newAdUrl = newAdUrl.split('[APP_BUNDLE]').join(adHandler.getBundleId());
            }
            if (newAdUrl.indexOf('[FT_CACHEBUSTER]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CACHEBUSTER]').join(encodeURI(Date.now()));
            }
            if (newAdUrl.indexOf('[IP]') > -1) {
                newAdUrl = newAdUrl.split('[IP]').join(encodeURI(platform?.getIp()));
            }
            if (newAdUrl.indexOf('[UA]') > -1) {
                newAdUrl = newAdUrl.split('[UA]').join(encodeURI(platform?.getUA()));
            }
            if (newAdUrl.indexOf('[LIMITED_AD_TRACKING]') > -1) {
                newAdUrl = newAdUrl.split('[LIMITED_AD_TRACKING]').join(appConfig.deviceLmtVal);
            }
            if (newAdUrl.indexOf('[CONTENT_ID]') > -1) {
                newAdUrl = newAdUrl.split('[CONTENT_ID]').join(vodInfo['node_id']);
            }
            if (newAdUrl.indexOf('[CONTENT_GENRE]') > -1) {
                newAdUrl = newAdUrl.split('[CONTENT_GENRE]').join(encodeURI($.trim(vodInfo['primary_genre'])));
            }
            if (newAdUrl.indexOf('[CONTENT_SERIES]') > -1) {
                newAdUrl = newAdUrl.split('[CONTENT_SERIES]').join(encodeURI($.trim(vodInfo['series_name'])));
            }
            if (newAdUrl.indexOf('[CONTENT_TITLE]') > -1) {
                newAdUrl = newAdUrl.split('[CONTENT_TITLE]').join(encodeURI($.trim(vodInfo['title'])));
            }            
            if (newAdUrl.indexOf('[FT_CONTENT_CHANNEL]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CONTENT_CHANNEL]').join(encodeURI($.trim(vodInfo['title'])));
            }
            if (newAdUrl.indexOf('[US_PRIVACY]') > -1) {
                newAdUrl = newAdUrl.split('[US_PRIVACY]').join(appApiConfig.appConfig.us_privacy);
            }
            if (newAdUrl.indexOf('[FT_DEDUPE_ID]') > -1) {
                ads.adBreakNumber = context == 'preroll' ? 0 : (ads.adBreakNumber + 1);
                var dedupeId = platform?.getDeviceId() + Date.now() + vodInfo['node_id'] + ads.adBreakNumber;
                newAdUrl = newAdUrl.split('[FT_DEDUPE_ID]').join(dedupeId);
            }
            if (newAdUrl.indexOf('[POD_DURATION]') > -1) {
                var remainingTime = appConfig.maxTotalAdDuration - ads.adsPlayedTime;
                newAdUrl = newAdUrl.split('[POD_DURATION]').join(remainingTime);
                newAdUrl += '&pod_max_dur=' + remainingTime;
            }
            if (newAdUrl.indexOf('[FT_NO_OF_SLOTS]') > -1) {                      
                let adObj = app?.adObj;
                var noOfSlots = context == 'preroll' ? this.cuePointsManager.noPreAds : this.cuePointsManager.noMidAds;
                if(appConfig?.adSdkToUse == 'ima'){
                    if(breakPosition == 1 && context == 'midroll'){
                        const { appConfig, appState } = AppData as AppSetup;
                        const appApiConfig = appState?.getAppApiConfig();
                        noOfSlots = Number(appApiConfig?.appConfig?.firstmidrollsize);
                    }
                }
                
                newAdUrl = newAdUrl.split('[FT_NO_OF_SLOTS]').join(noOfSlots);
            }
            /** Changes for XFIN-977 Comcast | AVOD - Add new macros - 2 */            
            if (newAdUrl.indexOf('[FT_BUILD]') > -1) {
                newAdUrl = newAdUrl.split('[FT_BUILD]').join(appConfig?.buildVersion);
            }            
            if (newAdUrl.indexOf('[FT_PLAYLIST]') > -1) {                                
                let playListKeys = '';
                let keys = app?.videoPlaylistGrid.getRowKey();                

                if(keys){
                    playListKeys = keys;
                }
                newAdUrl = newAdUrl.split('[FT_PLAYLIST]').join(playListKeys);
            }
            if (newAdUrl.indexOf('[FT_CONTENT_AG]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CONTENT_AG]').join($.trim(vodInfo['age_group']));
            }
            if (newAdUrl.indexOf('[FT_CONTENT_GENDER]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CONTENT_GENDER]').join($.trim(vodInfo['gender']));
            }
            if (newAdUrl.indexOf('[FT_CONTENT_BRAND]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CONTENT_BRAND]').join($.trim(vodInfo['brands']));
            }
            if (newAdUrl.indexOf('[FT_CONTENT_LANGUAGE]') > -1) {
                newAdUrl = newAdUrl.split('[FT_CONTENT_LANGUAGE]').join($.trim(vodInfo['content_language']));
            }
            if (newAdUrl.indexOf('[FT_COPPA]') > -1) {                
                const genre = appApiConfig?.appConfig?.genre;        
                let coppa = 0;
                if(genre && genre.toLocaleLowerCase() !== "movies"){
                    coppa = 1;
                }
                newAdUrl = newAdUrl.split('[FT_COPPA]').join(coppa);
            }
            if (newAdUrl.indexOf('[FT_DEVICE_MAKE]') > -1) {
                newAdUrl = newAdUrl.split('[FT_DEVICE_MAKE]').join(platform?.getMake());
            }
            /** Changes for XFIN-977 Comcast | AVOD - Add new macros - 2 */

            /*if (newAdUrl.indexOf('[FT_DEDUPE_ID]') > -1) {
                appState.ads.adBreakNumber = context == 'preroll' ? 0 : (appState.ads.adBreakNumber + 1);
                var dedupeId = appConfig.currentDeviceId + Date.now() + vodInfo['node_id'] + appState.ads.adBreakNumber;
                newAdUrl = newAdUrl.split('[FT_DEDUPE_ID]').join(dedupeId);
            }*/
            // Adding support for nonce macro for google inventory enabling - 10 Jan 2023
            //Commenting below line for XFIN-1005 Comcast | Ad Macros | Remove hardcoded nonce macro
            //newAdUrl = newAdUrl + '&nonce=[GOOGLE_INSTREAM_VIDEO_NONCE]';
            // } catch(e) {

            // }
            // Live Macros - END

            Logger.printLog('data', 'replacing macros adUrl after replacing macros: ', newAdUrl);

            return newAdUrl;

        } else {
            return;
        }
    }

    onContentPauseRequested = () => {
        const { appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        app.videoObj.pauseContent();
        this.adHandler.showAdVideoElem();
    }
    onContentResumeRequested = () => {
        const { appState } = AppData as AppSetup;
        const app: AppModel = appState?.getApp()!;
        if(!app.videoObj.isPaused()) {
            return;
        }         
        if (
            appState.player.videoStartedFromResumePoint !== 0 &&
            appState.player.pausedTime == 0
          ) {
            app.videoObj.resumeVideoPlayback(
              appState.player.videoStartedFromResumePoint,
              "onContentResumeRequested"
            );
          } else {
            app.videoObj.resumeVideoPlayback(
              appState.player.pausedTime,
              "onContentResumeRequested"
            );
          }



          this.totalAds=0
          this.adHandler.hideAdVideoElem();
    }

    onAdComplete = () => {		
	}

	
}
